import {YANDEX_METRIKA_ID} from '@web-landing/analytics/ids';

export const ym_log = {
  instructionButtonCopyLinkYM: () => {
    window.ym(YANDEX_METRIKA_ID, 'reachGoal', 'main_button_download_file');
  },
};
